import helpCenterNo from '../resources/no/help-center.json';
import helpCenterSe from '../resources/se/help-center.json';
import { HelpCenterLanguageResources } from '../types/HelpCenterLanguageResources';

export const helpCenterI18nResources: HelpCenterLanguageResources = {
  no: { helpCenter: helpCenterNo },
  se: { helpCenter: helpCenterSe },
};
